import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Truck } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    const role = localStorage.getItem("pending_role") || "customer";
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId, role });
        localStorage.removeItem("pending_role");
        setUser(data);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/auth", { replace: true }), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background">
      <Truck className="h-10 w-10 text-kinetic animate-pulse" />
      <p className="font-mono text-sm text-muted-foreground uppercase tracking-widest">
        {error || "Signing you in…"}
      </p>
    </div>
  );
}
